import parseBoolean from './utils/parseBoolean';
import isHttpStream from './utils/isHttpStream';

function toHttps(url) {
  return url.replace('http://', 'https://');
}

export default {
  fromTuneResponse: function (streams, forceHttpsStreams) {
    return streams.map(function (stream) {
      return {
        url: forceHttpsStreams ? toHttps(stream.url) : stream.url,
        reliability: stream.reliability,
        format: stream.mediaType.toLowerCase(),
        id: stream.guideId || undefined,
        nextGuideId: stream.nextGuideId || undefined,
        itemToken: stream.itemToken || undefined,
        position: stream.position || 0,
        requiresUnwrap: !!stream.isProxy,
        isLiveSeekStream: parseBoolean(stream.liveSeekStream),
        isHlsAdvanced: parseBoolean(stream.isHlsAdvanced),
        useStreamMetadata: parseBoolean(stream.useStreamMetadata),
        isMidrollEnabled: parseBoolean(stream.isAdClippedContentEnabled),
        isBoostStation: parseBoolean(stream.isBoostStation),
        rejectReason: stream.rejectReason,
        wasManuallyUpgradedToHttps: Boolean(
          isHttpStream(stream.url) && forceHttpsStreams,
        ),
      };
    });
  },
  /**
   * Function to map the unwrap stream response to an internal web-tuner
   * stream model.
   *
   * @param streams {array} an array of streams returned from the unwrap streams call
   * @param forceHttpsStreams {boolean} upgrade all stream urls to https
   * @param metadata {object} metadata that should be mapped to each stream. (ex. isLiveSeekStream)
   * @returns {array}
   */
  fromUnwrapResponse: function (streams, forceHttpsStreams, metadata = {}) {
    return streams.map(function (stream) {
      return {
        url: forceHttpsStreams ? toHttps(stream.url) : stream.url,
        reliability: stream.reliability,
        format: stream.mediaType.toLowerCase(),
        id: 'e' + stream.streamId,
        requiresUnwrap: false,
        wasManuallyUpgradedToHttps: Boolean(
          isHttpStream(stream.url) && forceHttpsStreams,
        ),
        ...metadata,
      };
    });
  },
};
